import React from 'react';

import cn from 'classnames';

import st from './shared.module.sass';

export function Group({ children, className }) {
  return (
    <main className={cn(st.Group, className)}>
      {children}
    </main>
  );
}
